import React from "react";
import { graphql, useFragment } from "react-relay";

import type { NoteEdgesType, StreamUsersType } from "~/stream/types";

import type { context_StreamUsersTypeContext_streamUsers$key as StreamUsersFragmentKey } from "~/__generated__/context_StreamUsersTypeContext_streamUsers.graphql";

const streamUsersFragment = graphql`
	fragment context_StreamUsersTypeContext_streamUsers on NoteStream {
		notestreamusers {
			id
			accessType
			user {
				id
				email
				image
				fullName
				lastName
				firstName
				isActive
				isConfigured
				isGuest
				hasReceivedInvites
				isTopUser
				isExternal
				account {
					id
					name
				}
			}
		}
	}
`;

export const StreamContentContext = React.createContext<NoteEdgesType>([]);
StreamContentContext.displayName = "StreamContentContext";

export const StreamUsersContext = React.createContext<StreamUsersType>([]);
export const StreamUsersContextProvider = ({
	children,
	stream: streamKey,
}: {
	children: React.ReactNode;
	stream: StreamUsersFragmentKey;
}) => {
	const stream = useFragment(streamUsersFragment, streamKey);
	return <StreamUsersContext.Provider value={stream.notestreamusers}>{children}</StreamUsersContext.Provider>;
};

StreamUsersContext.displayName = "StreamUsersContext";
